import { useEffect, useState } from 'react';

import { useApiClient } from '@travel/api-client';

import { translate } from 'store/translate/api';

import type { TranslateRequestObj } from 'Translate-Types';

function useServerTranslation(textObject: TranslateRequestObj[], shouldTranslate: boolean = false) {
  const [isLoading, setIsLoading] = useState(false);
  const [translatedText, setTranslatedText] = useState<TranslateRequestObj[]>();
  const [translationType, setTranslationType] = useState('');
  const apiClient = useApiClient();

  useEffect(() => {
    async function fetchTranslation() {
      try {
        if (shouldTranslate && textObject) {
          setIsLoading(true);
          const response = await translate(apiClient, {
            contents: textObject,
          });
          const { contents, translationType } = response;
          setTranslatedText(contents);
          setTranslationType(translationType);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchTranslation();
  }, [apiClient, shouldTranslate, textObject]);

  return { isLoading, translatedText, translationType, apiClient };
}

export default useServerTranslation;
